import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ['sentiment', 'message', 'messageTitle', 'messageResponse', 'thanks']

    connect() {
        this.messageTarget.classList.add('hidden')
        this.thanksTarget.classList.add('hidden')
        this.element.classList.remove('hidden')
    }

    postPositive() {
        this.postSentiment('positive')
    }

    postNegative() {
        this.postSentiment('negative')
        this.messageTitleTarget.innerHTML = 'What were you looking for?'
    }

    postSentiment(sentiment) {
        this.messageTarget.classList.remove('hidden')
        this.messageResponseTarget.focus()
        this.sentimentTarget.classList.add('hidden')

        axios.post('/feedback-widget', {
            sentiment: sentiment,
            os_browser: JSON.stringify(Platform)
        })
        .then(response => {
            this.id = response.data.id
            this.token = response.data.token

            var sentimentSentEvent = new CustomEvent('feedback.sentiment_sent', {
                detail: {
                    id: this.id,
                    sentiment: sentiment
                }
            });

            window.dispatchEvent(sentimentSentEvent)
        })
        .catch(error => {
            console.log(error)

            alert('Something went wrong! Please try again.')

            this.messageTarget.classList.add('hidden')
            this.messageResponseTarget.blur()
            this.sentimentTarget.classList.remove('hidden')
        });
    }

    postMessage() {
        var value = this.messageResponseTarget.value.trim()

        if (value.length < 1 || value.length > 500) {
            alert('Your message must be between 1 and 500 characters in length.')
            return
        }

        if (this.id === undefined) {
            alert('We\'re still processing your first request, please wait a few moments and try again.')
            return
        }

        axios.patch('/feedback-widget/' + this.id, {
            message: value,
            token: this.token
        })
        .then(response => {
            this.id = null
            this.token = null

            var messageSentEvent = new CustomEvent('feedback.message_sent')
            window.dispatchEvent(messageSentEvent)
        })
        .catch(error => {
            console.log(error)

            alert('Something went wrong! Please try again.')

            this.messageTarget.classList.remove('hidden')
            this.thanksTarget.classList.add('hidden')
        });

        this.messageTarget.classList.add('hidden')
        this.thanksTarget.classList.remove('hidden')
    }
}
